<template>
  <div>
    <img v-if="generatCanvas" class="w-100" :src="imgCreated" alt="" />
    <div
      v-else
      :class="[
        smallFront
          ? 'fullNFreeN pt4 pl4'
          : miniSmallFront
          ? 'fullNFreeN pt2 pl2'
          : 'fullNFreeN pt4 pl8'
      ]"
      :style="{
        background: fullNFreeN.bgimg ? 'url(' + fullNFreeN.bgimg + ') no-repeat center' : '#fc0324',
        'background-size': '100% 100%'
      }"
    >
      <p
        :class="[
          smallFront
            ? 'scoped_color-06 scoped_f8 ml5'
            : miniSmallFront
            ? 'scoped_color-06 scoped_f5 ml2'
            : 'scoped_color-06 f10 ml11'
        ]"
      >
        买{{ fullNFreeN.fullNums }}赠{{ fullNFreeN.freeNums }}低至
      </p>
      <p
        :class="[
          smallFront
            ? 'f10 flex ai-fe scoped_color-06'
            : miniSmallFront
            ? 'scoped_f5 flex ai-fe scoped_color-06'
            : 'f17 flex ai-fe scoped_color-06'
        ]"
      >
        ¥
        <span :class="[smallFront ? 'f17 lh17' : miniSmallFront ? 'f10 scoped_lh10' : 'f32 lh32']">
          {{ fullNFreeN.sales_price.split('.')[0] }}
        </span>
        .{{ fullNFreeN.sales_price.split('.')[1] }}/盒
      </p>
      <p
        :class="[
          smallFront
            ? 'scoped_color-06 scoped_f8 ml5 td-lt'
            : miniSmallFront
            ? 'scoped_color-06 scoped_f5 ml2 td-lt'
            : 'scoped_color-06 f10 ml11 td-lt'
        ]"
      >
        原价￥{{ fullNFreeN.cost_price }}/盒
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goodsFloatImg',
  data() {
    return {
      bgimg: '',
      imgCreated: ''
    }
  },
  props: {
    generatCanvas: {
      type: Boolean,
      default: false
    },
    fullNFreeN: {
      type: Object,
      default: () => ({}) // 修正默认值
    },
    smallFront: {
      type: Boolean,
      default: false
    },
    miniSmallFront: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  destroyed() {},
  watch: {
    fullNFreeN: {
      handler(val) {
        if (this.generatCanvas) {
          if (val.bgimg) {
            this.imgToRedirect()
          } else {
            this.createImg()
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    imgToRedirect() {
      var url = this.$ajax.toRedirect_URL + '?path=' + this.fullNFreeN.bgimg
      var that = this
      that
        .$customRequestAjax(url, {
          responseType: 'blob'
        })
        .then((res) => {
          if (res.status === 200) {
            var blob = res.data
            if (blob.size > 0) {
              var reader = new FileReader()
              reader.readAsDataURL(blob) // 转换为base64，可以直接放入a标签href
              reader.onload = function (e) {
                that.bgimg = e.currentTarget.result
                that.createImg()
              }
            }
          }
        })
    },
    createImg() {
      const canvas = document.createElement('canvas')
      canvas.width = 750
      canvas.height = 141
      const ctx = canvas.getContext('2d')
      var that = this

      // Draw background
      if (this.fullNFreeN.bgimg) {
        const bgImg = new Image()
        bgImg.crossOrigin = 'anonymous'
        bgImg.onload = () => {
          ctx.drawImage(bgImg, 0, 0, 750, 141)
          drawTexts()
          finish()
        }
        bgImg.src = this.bgimg
      } else {
        ctx.fillStyle = '#fc0324'
        ctx.fillRect(0, 0, 750, 141)
        drawTexts()
        finish()
      }

      function drawTexts() {
        // 买X赠X低至
        ctx.font = '24px Arial'
        ctx.fillStyle = '#060606'
        ctx.fillText(`买${that.fullNFreeN.fullNums}赠${that.fullNFreeN.freeNums}低至`, 55, 40)

        // ¥ price
        ctx.font = '34px Arial'
        ctx.fillText('¥', 30, 95)

        // 主价格
        ctx.font = '64px Arial'
        ctx.fillText(
          that.fullNFreeN.sales_price ? that.fullNFreeN.sales_price.split('.')[0] : '',
          50,
          95
        )
        const integerPart = that.fullNFreeN.sales_price
          ? that.fullNFreeN.sales_price.split('.')[0]
          : ''
        const integerWidth = ctx.measureText(integerPart).width
        console.log('integerWidth', integerWidth)
        // 小数点
        ctx.font = '34px Arial'
        ctx.fillText(
          that.fullNFreeN.sales_price ? '.' + that.fullNFreeN.sales_price.split('.')[1] : '',
          50 + integerWidth,
          95
        )
        ctx.font = '24px Arial'
        ctx.fillText('/盒', 100 + integerWidth, 95)

        // 原价
        ctx.font = '20px Arial'
        ctx.fillStyle = '#060606'
        const costText = `原价￥${that.fullNFreeN.cost_price}/盒`
        ctx.fillText(costText, 55, 130)

        // 删除线
        const textWidth = ctx.measureText(costText).width
        ctx.strokeStyle = '#060606'
        ctx.beginPath()
        ctx.moveTo(55, 125)
        ctx.lineTo(55 + textWidth, 125)
        ctx.stroke()
      }

      function finish() {
        // 导出图片
        that.imgCreated = canvas.toDataURL('image/png')
        that.$emit('img-created', that.imgCreated)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.fullNFreeN {
  max-height: 0.71rem;
}
.scoped_color-06 {
  color: #060606;
}
.scoped_f8 {
  font-size: 0.08rem;
  zoom: 0.8;
}
.scoped_f5 {
  font-size: 0.05rem;
  zoom: 0.5;
}
.scoped_f4 {
  font-size: 0.04rem;
  zoom: 0.4;
}
.scoped_lh10 {
  line-height: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/goodsFloatImg.vue